import React, { useState } from 'react';

function Payslip() {

    return (
        <div>
            Payslip


        </div>
    )
}

export default Payslip